export type ObjType = {
  [key: string]: string;
};

/**
 * 共通Entity
 */
export class BaseEntity {
  /** 作成者 */
  public createUser: string = "";
  /** 作成日時 */
  public createDate: Date = new Date();
  /** 更新者 */
  public updateUser: string = "";
  /**  更新日時 */
  public updateDate: Date = new Date();
  /** 削除日時 */
  public deleteDate: Date = new Date();
}
